<template>
    <div class="saturnalia-map-wrapper">
        <iframe frameBorder="0" id="output-frame-id" class="sat-iframe"></iframe>
    </div>
</template>

<script>
export default {
    name: "SaturnaliaInfoIframe",
    head() {
        return {
            title: 'Saturnalia wine map | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                },
                {
                    hid: 'robots',
                    name: 'robots',
                    content: 'noindex'
                }
            ],
            bodyAttrs: {
                class: 'barcode-page'
            }
        }
    },
    methods: {
        saturnaliaApiIntegration(token, frameId, model, model_id, vintage) {
            if (!model) {
                model = "variety";
            }

            var xhr = new XMLHttpRequest();

            xhr.open('GET', 'https://api.saturnalia.tech/data/iframe-integration-lwin-3d/' + model + '/' + model_id.toString() + '/' + vintage.toString() + '/');
            xhr.onreadystatechange = handler;
            xhr.responseType = 'blob';

            xhr.setRequestHeader('Authorization', token);
            xhr.send();

            function handler() {
                if (this.readyState === this.DONE) {
                    if (this.status === 200) {
                        var data_url = URL.createObjectURL(this.response);
                        var iframe = document.querySelector(frameId);
                        iframe.src = data_url;

                        Object.defineProperty(iframe, 'src', {
                            writable: false
                        });
                    }
                }
            }
        }
    },
    mounted() {
        let _lwin = this.$route.query.lwin;
        let _vintage = this.$route.query.vintage;
        this.saturnaliaApiIntegration(
            '3515a51c36d0d65ea536377023f02aa09a7e23ca',
            '#output-frame-id',
            'wine',
            _lwin,
            _vintage
        )
    }
}
</script>

<style scoped>
.sat-iframe {
    width: 100%;
    height: 100%;
    min-height: 300px;
    padding: 0;
    margin: 0;
}
</style>
<style>
.barcode-page .theme--dark.v-sheet.header-toolbar,
.barcode-page .main-footer,
.barcode-page .header-toolbar-not-logged,
.barcode-page .smartbanner,
.cc_dialog.headline,
.barcode-page #iubenda-cs-banner  {
    display: none !important;
}

.barcode-page .v-main {
    padding-top: 0 !important;
}

.smartbanner-show {
    margin-top: 0 !important;
}
</style>
